import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

/** A light, readable tooltip: the note in bold, then one line per step of the working. */
export default function ImpactTooltip({ note, explain, children }: { note: string; explain: string[]; children: React.ReactElement }) {
  return (
    <Tooltip
      arrow
      componentsProps={{ tooltip: { sx: { bgcolor: '#fff', color: '#111827', border: '1px solid', borderColor: 'divider', boxShadow: 3, maxWidth: 440, p: 1.25 } }, arrow: { sx: { color: '#fff', '&:before': { border: '1px solid', borderColor: 'divider' } } } }}
      title={(
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600, color: '#111827', mb: 0.5 }}>{note}</Typography>
          {explain.map((l, i) => <Typography key={i} variant="body2" sx={{ color: '#374151', fontSize: 12.5, lineHeight: 1.4, mb: 0.25 }}>· {l}</Typography>)}
        </Box>
      )}
    >
      {children}
    </Tooltip>
  );
}
